import {useTranslation} from '@aboutyou/i18n';
import {
  COLORS,
  FullWidthImage,
  mediaExtraLargeScreens,
  mediaMinL,
  Text,
} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';

const IMAGE_URL =
  '//cdn.aboutstatic.com/file/0f7481cd84b4944576e624bef512d862?quality=90';

export const NotFoundInformation = () => {
  const {t} = useTranslation();

  const headline = t('Uh oh - 404');
  const subline = t('Sorry, this page no longer exists.');

  return (
    <NotFoundHeader data-testid="404Teaser">
      <FullWidthImage
        dataTestId="notFoundHeaderImage"
        imageUrl={IMAGE_URL}
        description={''}
        aspectRatio={'4:3'}
        highPrioImage
      />
      <CenterContainer>
        <Text
          data-testid="notFoundTitle"
          color="White"
          size="px40"
          weight="bold"
        >
          {headline}
        </Text>
        <Text data-testid="notFoundSubtitle" color="White" size="px16">
          {subline}
        </Text>
      </CenterContainer>
    </NotFoundHeader>
  );
};

const NotFoundHeader = styled.section`
  position: relative;
  display: flex;
  justify-content: center;
  background-color: ${COLORS.Grey1};

  height: 393px;

  @media ${mediaExtraLargeScreens} {
    height: 554px;
  }

  @media ${mediaMinL} {
    height: 600px;
  }
`;

const CenterContainer = styled.div`
  position: absolute;

  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 26.5px;
`;
